module.exports = __webpack_public_path__ + "img/app-icon-6.2e601e0a.svg";